export const requiredField = 'Campo obrigatório';

export const passwordNotMatch = 'As senhas não conferem';

export const passwordRuleSet = 'Senha não atende regras de definição';

export const invalidDate = 'Formato de data inválida';

export const invalidEmailFormat = 'Formato de email inválido';

export const maxFiles = 'Máximo de 10 documentos por solicitação';
